import { render, staticRenderFns } from "./NeuBoard.vue?vue&type=template&id=75a8bcce&scoped=true&"
import script from "./NeuBoard.vue?vue&type=script&lang=js&"
export * from "./NeuBoard.vue?vue&type=script&lang=js&"
import style0 from "./NeuBoard.vue?vue&type=style&index=0&id=75a8bcce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a8bcce",
  null
  
)

export default component.exports